import { isNullOrUndefined } from '@syncfusion/ej2-base';
import { TextSearchResult } from './text-search-result';
/**
 * @private
 */
export class TextSearchResults {
    constructor(owner) {
        this.currentIndex = -1;
        this.owner = owner;
    }
    get length() {
        if (this.innerList === undefined) {
            return 0;
        }
        return this.innerList.length;
    }
    get currentSearchResult() {
        if (this.innerList === undefined || this.currentIndex < 0 || this.currentIndex >= this.length) {
            return undefined;
        }
        return this.innerList[this.currentIndex];
    }
    addResult() {
        const textSearchResult = new TextSearchResult(this.owner);
        if (isNullOrUndefined(this.innerList)) {
            this.innerList = [];
        }
        this.innerList.push(textSearchResult);
        return textSearchResult;
    }
    clearResults() {
        this.currentIndex = -1;
        if (!isNullOrUndefined(this.innerList)) {
            for (let i = this.innerList.length - 1; i >= 0; i--) {
                this.innerList[parseInt(i.toString(), 10)].destroy();
                this.innerList.splice(i, 1);
            }
        }
    }
    indexOf(result) {
        if (isNullOrUndefined(this.innerList)) {
            return -1;
        }
        return this.innerList.indexOf(result);
    }
    destroy() {
        if (!isNullOrUndefined(this.innerList)) {
            this.clearResults();
        }
        this.innerList = undefined;
    }
}
